import { ScanSection } from "./ScanSection";
import { AppText } from "@/components/Text/AppText";
import { IScanResultItem, IScanResults } from "@/types/atsScan";

interface ScanResultsProps {
    scanResults?: IScanResults;
    scanDate?: string;
    className?: string;
    isScanning?: boolean;
    title?: string;
}

export const ScanResults = ({
    scanResults,
    scanDate,
    className = "",
    isScanning = false,
    title,
}: ScanResultsProps) => {
    const sections = Object.entries(scanResults ?? {});

    return (
        <div className={`space-y-4 ${className}`}>
            {isScanning && (
                <div className="mx-4 mt-16 flex flex-col items-center gap-2">
                    <AppText
                        variant="labelsbuttons"
                        className="text-neutral-900"
                    >
                        Generating recommendations...
                    </AppText>
                    <AppText
                        variant="regular"
                        className="text-neutral-600"
                    >
                        This shouldn&apos;t take long
                    </AppText>
                </div>
            )}

            {!isScanning && scanResults && (
                <>
                    {(title || scanDate) && (
                        <div className="flex items-center justify-between gap-2 px-4">
                            {title && (
                                <AppText
                                    variant="contextheading"
                                    className="text-neutral-700"
                                >
                                    {title}
                                </AppText>
                            )}
                            {scanDate && (
                                <AppText
                                    variant="footnote"
                                    className="text-neutral-500"
                                >
                                    Last scan: {scanDate}
                                </AppText>
                            )}
                        </div>
                    )}
                    <div className="space-y-4">
                        {sections.map(([sectionKey, sectionData]) => {
                            if (!sectionData) return null;

                            return (
                                <ScanSection
                                    key={sectionKey}
                                    sectionKey={sectionKey}
                                    sectionData={
                                        sectionData as Record<
                                            string,
                                            IScanResultItem
                                        >
                                    }
                                />
                            );
                        })}
                    </div>
                </>
            )}
        </div>
    );
};
